import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Productlifecycle(props) {
  return (
    <div>
      <Container className="h-100 tekrevol_dark_bg p-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Cloud">
              <h2>Ensure Business Innovation via our Serverless Computing</h2>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
            <p>
              We help businesses remain ahead of the curve by providing a full
              range of serverless computing solutions. Transitioning to our
              serverless architecture delivers a competitive advantage by
              increasing agility, refining procedures, and sharpening focus.
            </p>
            <p>
              Experience the resilience and scalability of serverless
              architecture, our modular strategy shortens time-to-market,
              allowing businesses to provide great customer experiences that
              surpass expectations.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Productlifecycle;
